module.exports = __webpack_public_path__ + "static/media/E_WHITOUT_B_Cool-Grey-1C.bc0bc7a9.jpg";